import { IconMinus, IconPlus } from '@tabler/icons-react';
import _debounce from 'lodash/debounce';
import React, { useContext } from 'react';
import { Accordion } from 'react-bootstrap';
import { useAccordionButton } from 'react-bootstrap/AccordionButton';
import AccordionContext from 'react-bootstrap/AccordionContext';
import { toast } from 'sonner';
import { postApi } from '../../../../api/call.api';
import { urlApi } from '../../../../api/url.api';
import ToggleBtn from '../../../../components/Toggle/ToggleBtn';
import { loadingHide, loadingShow } from '../../../../loadingUi/loading.controller';

const HeadingBlockOfCard = ({ dragButton, linkId, callback, data }) => {

    function ContextAwareToggle({ eventKey, callback }) {
        const { activeEventKey } = useContext(AccordionContext);

        const decoratedOnClick = useAccordionButton(
            eventKey,
            () => callback && callback(eventKey),
        );

        const isCurrentEventKey = activeEventKey === eventKey;

        return (
            <div className="flex items-center rounded-md bg-[#E8EDFC] gap-3 p-2 cursor-pointer" onClick={decoratedOnClick}>
                {dragButton}
                <p className='mb-0 text-sm font-semibold'>About</p>
                <div className="ms-auto"></div>
                <ToggleBtn onClickFunction={(e) => onBlockStatusUpdate(e)} state={data?.status == 1} />
                <button className='bg-white p-1.5 rounded-full' onClick={decoratedOnClick}>{isCurrentEventKey ? <IconMinus size={20} /> : <IconPlus size={20} />}</button>
            </div>
        );
    }

    async function update(postDetails) {
        let postData = {
            linkId: linkId,
            postData: postDetails
        }
        let resp = await postApi(postData, urlApi.editBlockDataOfCard);
        loadingHide();
        if (resp?.responseCode === 200) {
            if (callback) {
                callback();
            }
        }
        if (resp.responseCode === 500) {
            toast.error(resp.message);
        }
    }

    const onTitleChange = (e) => {
        let title = e.target.value;
        let postDetails = [{
            "key": "headingText.title",
            "value": title
        }]
        update(postDetails);
    }

    const onDescriptionChange = (e) => {
        let description = e.target.value;
        let postDetails = [{
            "key": "headingText.description",
            "value": description
        }]
        update(postDetails);
    }

    const onBlockStatusUpdate = (e) => {
        e.stopPropagation();
        loadingShow();
        let status = data?.status == 1 ? 2 : 1;
        let postDetails = [{
            "key": "headingText.status",
            "value": status
        }]
        update(postDetails);
    }

    return (

        <div className='w-full rounded-md overflow-hidden border border-[#E8EDFC]'>
            <Accordion>
                <Accordion.Item eventKey="0">
                    <ContextAwareToggle eventKey={"0"} />
                    <Accordion.Body>
                        <div className="p-2">
                            <p className="text-sm font-semibold mb-1.5">Title</p>
                            <input type="text" className="form-control mb-2 w-full" placeholder="" id={'title'} defaultValue={data?.title} maxLength={255} onChange={_debounce((e) => onTitleChange(e), 600)} />
                            <p className="text-sm font-semibold">Description</p>
                            <p className="text-xs font-light mb-1.5">*maximum 500 words</p>
                            <textarea type="text" className="form-control mb-2 w-full" placeholder="" id={'description'} rows={5} defaultValue={data?.description} maxLength={500} onChange={_debounce((e) => onDescriptionChange(e), 800)} ></textarea>
                        </div>
                    </Accordion.Body>
                </Accordion.Item>
            </Accordion>
        </div>
    )
}

export default HeadingBlockOfCard